import {IServiceFactory} from "../../../service-factory.interface";
import {Price} from "../../../currency/price";
import {ITravelTaxViewModel} from "./travel-tax.view-model.interface";
import {BookingModel} from "../booking.model";

export class TravelTaxModel implements ITravelTaxViewModel {
    constructor(public readonly code: string,
                public readonly quantity: number,
                public readonly price: Price,
                private readonly services: IServiceFactory) {
    }

    get total(): Price {
        return this.price.multiply(this.quantity);
    }

    get description(): string {
        return this.services.language.getTravelTaxTranslation(this.code);
    }

    static groupTaxes(taxes: ITravelTaxViewModel[], booking: BookingModel): TravelTaxModel[] {
        const taxesGroupedByCode = taxes.groupByKey(t => t.code + t.price.toString());

        return Object.keys(taxesGroupedByCode).map(code => {
            const taxes = taxesGroupedByCode[code];
            const quantity = taxes.sum(t => t.quantity);
            return new TravelTaxModel(taxes[0].code, quantity, taxes[0].price, booking.services);
        })
    }
}